import ResyRewardsIntro from './ResyRewardsIntro';

export default ResyRewardsIntro;
